import {
  BASE_URL,
  LOINC_DATA,
  LOINC_VIEW,
  LOINC,
  ERROR_MSG,
  LOINC_ACTIVE,
  API_GATEWAY_KEY,
  LOINC_SEARCHTEXT,
  LOINC_SIZE,
} from "./Constants";
import Cookies from "js-cookie";

export const fetchLoincData = async (pageNo, recordsPerPage, filter) => {
  let response = await fetch(
    `${BASE_URL}${LOINC_DATA}/${pageNo}/${recordsPerPage}`,
    {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
      body: JSON.stringify(filter),
    }
  );
  return response;
};

export const fetchLoincDataWithCondition = async (
  pageNo,
  recordsPerPage,
  condition,
  urlWithParams
) => {
  if (condition == null || condition === "") {
    return {
      genericList: [],
      totalPages: 1,
    };
  }
  let response = await fetch(
    `${BASE_URL}${LOINC_DATA}/${pageNo}/${recordsPerPage}?condition=${condition}&${urlWithParams}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  if (response.ok) {
    let data = await response.json();
    return data;
  } else if (response.status === 404) {
    return {
      genericList: [],
      totalPages: 1,
    };
  } else {
    return ERROR_MSG;
  }
};

export const addNewLoinc = async (form) => {
  let response = await fetch(`${BASE_URL}${LOINC}`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(form),
  });
  let data = await response.json();
  return data;
};

export const fetchLoincById = async (loincId) => {
  let response = await fetch(`${BASE_URL}${LOINC_VIEW}/${loincId}`, {
    headers: {
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  return response;
};

export const updateLoincRecord = async (form) => {
  let response = await fetch(`${BASE_URL}${LOINC}`, {
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(form),
  });
  let data = await response.json();
  return data;
};

export const removeLoincRecord = async (loincId) => {
  let response = await fetch(`${BASE_URL}${LOINC}/${loincId}`, {
    method: "delete",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  if (!response.ok) {
    return ERROR_MSG;
  }
};

export const fetchAllActiveLoincData = async () => {
  let response = await fetch(`${BASE_URL}${LOINC_ACTIVE}`, {
    headers: {
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  return response;
};


export const searchLoincWithLimit = async (size, text) => {
 let response = await fetch(`${BASE_URL}${LOINC_SIZE}/${size}${LOINC_SEARCHTEXT}?searchText=${text}`, {
    headers: {
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  return response;
};